import { Home } from './Home';

export const route: {
	name: string;
	path: string;
	exact: boolean;
	component: () => React.JSX.Element;
} = {
	name: 'HOME',
	path: '/',
	exact: true,
	component: Home,
};
